'use strict';

var $ = require('../internals/export');

var getBuiltIn = require('../internals/get-built-in');

var bind = require('../internals/function-bind-context');

var call = require('../internals/function-call');

var aCallable = require('../internals/a-callable');

var anObject = require('../internals/an-object');

var speciesConstructor = require('../internals/species-constructor');

var getMapIterator = require('../internals/get-map-iterator');

var iterate = require('../internals/iterate'); // `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods


$({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  mapValues: function mapValues(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aCallable(newMap.set);
    iterate(iterator, function (key, value) {
      call(setter, newMap, key, boundFunction(value, key, map));
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true
    });
    return newMap;
  }
});